import { render, staticRenderFns } from "./ChangeCategory.vue?vue&type=template&id=3a5e34bd&scoped=true&"
import script from "./ChangeCategory.vue?vue&type=script&lang=js&"
export * from "./ChangeCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e34bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5e34bd')) {
      api.createRecord('3a5e34bd', component.options)
    } else {
      api.reload('3a5e34bd', component.options)
    }
    module.hot.accept("./ChangeCategory.vue?vue&type=template&id=3a5e34bd&scoped=true&", function () {
      api.rerender('3a5e34bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/CategoriesPage/ChangeCategory.vue"
export default component.exports